const skills = [
	{ label: 'Microservices & Cloud Architecture', value: 95 },
	{ label: 'API Design & Development', value: 92 },
	{ label: 'Generative AI & LLMs', value: 90 },
	{ label: 'Information Retrieval & RAG', value: 88 },
	{ label: 'Performance Optimization', value: 88 },
	{ label: 'Team Leadership & Mentoring', value: 85 },
];

export default skills;
